import { useCallback } from 'react'

import { useBalanceConfig, useTrackBalanceEvent } from '@features/balanceLedger'

import type { PeriodMode } from '../../../enums/periodMode'
import { useSuppliersBalanceFiltersContext } from '../contexts/suppliersBalanceFiltersContext'

interface UseTrackFilterOpenedProps {
  periodType?: PeriodMode
}

/**
 * Shared between the two places an add-filter menu can be opened: the toolbar's own menu (shown only while no
 * filter is active yet) and the filters bar's menu (shown once the bar is open, to add another filter type). Both
 * must report the same `Filter Opened` event with the same payload shape.
 */
export const useTrackFilterOpened = ({ periodType }: UseTrackFilterOpenedProps): (() => void) => {
  const { filterTypeOrder } = useBalanceConfig()
  const trackBalanceEvent = useTrackBalanceEvent()
  const { activeTypes } = useSuppliersBalanceFiltersContext()

  return useCallback(() => {
    /* eslint-disable @typescript-eslint/naming-convention */
    trackBalanceEvent('Filter Opened', {
      active_filters_count: activeTypes.length,
      available_filters: filterTypeOrder,
      period_type: periodType,
    })
    /* eslint-enable @typescript-eslint/naming-convention */
  }, [activeTypes.length, filterTypeOrder, periodType, trackBalanceEvent])
}
